const trimTrailingSlash = (value = "") => String(value || "").trim().replace(/\/+$/, "");

const getWindowOrigin = () => {
  if (typeof window !== "undefined" && window.location?.origin) {
    return trimTrailingSlash(window.location.origin);
  }
  return "";
};

export const SITE_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_SITE_URL || getWindowOrigin()
);

export const API_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_API_BASE_URL || SITE_BASE_URL
);

export const buildSiteUrl = (path = "/") => {
  const normalizedPath = String(path || "").startsWith("/") ? path : `/${path}`;
  return `${SITE_BASE_URL}${normalizedPath}`;
};

export const buildApiUrl = (path = "/") => {
  const normalizedPath = String(path || "").startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};
